export enum DecreeRxGroupEnum
{
  /** 戒菸 **/
  QuitSmoke = 1,
  /** 疫苗? **/
  Vacine = 2,
  /** 專案輸注液 */
  專案輸注液 = 3,
  /** 牙科牙位申報限制規則 */
  DentialRule = 4,
  /** 牙科週期性項目 */
  DentialPeriodItem = 5,
  /** 牙科處置醫令不得申請轉診加成者 */
  DentialCannotApplyPlus = 6,
  /** 牙科補牙限制之醫令 */ 
  DentialODLimtit = 7,
  /** 牙科根管治療限制之醫令 */ 
  DentialENDOLimit = 8,
  /** 牙科完診應提示之項目 */ 
  DentailAlertItems = 9,
  /** 牙科拔牙處置醫令項目 */
  DentailExtractionItmes = 10,
  /** 特殊療程 */
  SpecialSameTreat = 11,
  /** 特殊療程醫令 */ 
  SpecialSameTreatRx = 12,
  /** 床邊檢驗 */
  BedsideTesting = 13,
  /** 經費補助之醫令 */
  FundingSources = 14,
  /** 高風險病人氟化物治療限制之醫令 */
  DentailHighRiskItems = 16,
  /** 中醫醫令(第四五六七八章), 包含一般針傷, 複雜性針傷支付規範(部位, 輔助治療, 治療時間, 另開/未開內服藥) */
  ChineseRx = 28,
  CustomDiscount = 34
}

export class decreeRx {
  StdCode: string;
  Group: DecreeRxGroupEnum;
  Type: number;
  ValidationRule?: string;
  BeginDate: Date;
  EndDate: Date;
}

export class ValidationRule {
  ToothPosLimited: string; 
  NeedToCheckToothPos: string;
  NeedToCheckQuantity: string;
  NeedToRemark: string;
  EndDate: Date;
}

export class dentalICD10CM {
  StdCode: string;
  DeclareCode: string;
  ICD10Code: string;
  EName: string;
  CName: string;
  Remark: string;
}

export class dentalICD10PCS {
  Id: number;
  StdCode: string;
  ICD10Code: string;
  EName: string;
  CName: string;
  Remark: string;
}

export class PaymentRules
{
  /** 須針灸下列二個以上部位 */
  AcupuncturePoints: string;
  /** 須註明傷科部位 */
  TraumatologyPart: string;
  /** 針灸須合併以下任一輔助治療
   * CH01拔罐治療、CH02刮痧治療、CH03熱療(含紅外線治療)、CH04電療、CH05放血治療、CH06艾灸治療或CH07眼部特殊針灸。
   */
  AcupunctureComplementaryTherapy: string;
  /** 傷科須合併以下任一輔助治療
   * CH01拔罐治療、CH02刮痧治療、CH03熱療(含紅外線治療)、CH04電療、CH08藥薰治療、CH09膏布治療或CH10夾板固定治療。
   */
  TraumatologyComplementaryTherapy: string;
  /** 治療時間, 10分鐘, 20分鐘, 30分鐘, 40分鐘 */
  TreatmentTime?: number;
}
